import { i18n as __WEBPACK_EXTERNAL_MODULE_discourse_i18n_c659d411_i18n__ } from "discourse-i18n";
/******/ // The require scope
/******/ var __webpack_require__ = {};
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};

;// external "discourse-i18n"

;// ./src/plugin/assets/javascripts/discourse-markdown/waze-templates.ts


const TOPIC_ID_ATTRIBUTE_NAME = "topic";
const POST_NUMBER_ATTRIBUTE_NAME = "post";
const USER_PARAM_PREFIX = "p_";
const DATA_PARAM_PREFIX = "parameter";
function isPositiveWholeNumber(value) {
    if (typeof value === "number") {
        return Number.isInteger(value) && value > 0;
    }
    else if (typeof value === "string") {
        const num = Number(value);
        return Number.isInteger(num) && num > 0;
    }
    return false;
}
function insertIcon(state, icon) {
    const iconSvgToken = state.push(`svg_${icon}_open`, "svg", 1);
    iconSvgToken.attrs = [
        ["class", `fa d-icon d-icon-${icon} svg-icon svg-node`],
    ];
    const iconUseToken = state.push(`use_${icon}_open`, "use", 1);
    iconUseToken.attrs = [["href", `#w-${icon}`]];
    state.push(`use_${icon}_close`, "use", -1);
    state.push(`svg_${icon}_close`, "svg", -1);
}
function createValidPlaceholder(state, topicId, postNumber, baseUrl, attributes) {
    const anchorToken = state.push("link_open", "a", 1);
    anchorToken.attrs = [
        ["target", "_blank"],
        ["rel", "noopener noreferrer"],
        ["href", `${baseUrl}/t/${topicId}/${postNumber}`],
    ];
    const startToken = state.push("bbcode_open", "span", 1);
    startToken.attrs = [
        ["class", `wz-template-valid`],
        [`data-${TOPIC_ID_ATTRIBUTE_NAME}`, topicId],
        [`data-${POST_NUMBER_ATTRIBUTE_NAME}`, postNumber],
        ["data-waze-template", true],
    ];
    for (const [attrName, attrValue] of Object.entries(attributes)) {
        if (attrName.startsWith(USER_PARAM_PREFIX)) {
            const paramNameWithoutPrefix = attrName.replace(USER_PARAM_PREFIX, "");
            startToken.attrs.push([
                `data-${DATA_PARAM_PREFIX}-${paramNameWithoutPrefix}`,
                attrValue,
            ]);
        }
    }
    const contentToken = state.push("text", "", 0);
    contentToken.content = __WEBPACK_EXTERNAL_MODULE_discourse_i18n_c659d411_i18n__(`waze.templates.valid_template_placeholder`, {
        topicId,
        postNumber,
    });
    insertIcon(state, "external-link");
    state.push("bbcode_close", "span", -1);
    state.push("link_close", "a", -1);
}
function createInvalidPlaceholder(state, title, description) {
    const alertStartToken = state.push("html_raw", "", 1);
    alertStartToken.content = `<wz-alert variant="danger" level="page">`;
    const titleStartToken = state.push("bbcode_open", "span", 1);
    titleStartToken.attrs = [[`slot`, `header`]];
    titleStartToken.content = title;
    const titleContentToken = state.push("text", "", 0);
    titleContentToken.content = title;
    state.push("bbcode_close", "span", -1);
    const descriptionStartToken = state.push("bbcode_open", "span", 1);
    descriptionStartToken.attrs = [[`slot`, `body`]];
    descriptionStartToken.content = description;
    const descriptionContentToken = state.push("text", "", 0);
    descriptionContentToken.content = description;
    state.push("bbcode_close", "span", -1);
    const alertEndToken = state.push("html_raw", "", -1);
    alertEndToken.content = `</wz-alert>`;
}
function createMissingArgumentsPlaceholder(state) {
    return createInvalidPlaceholder(state, __WEBPACK_EXTERNAL_MODULE_discourse_i18n_c659d411_i18n__(`waze.templates.missing_attributes.title`), __WEBPACK_EXTERNAL_MODULE_discourse_i18n_c659d411_i18n__(`waze.templates.missing_attributes.description`));
}
function createInvalidArgumentsPlaceholder(state) {
    return createInvalidPlaceholder(state, __WEBPACK_EXTERNAL_MODULE_discourse_i18n_c659d411_i18n__(`waze.templates.invalid_attributes.title`), __WEBPACK_EXTERNAL_MODULE_discourse_i18n_c659d411_i18n__(`waze.templates.invalid_attributes.description`));
}
function createWzTemplateRule(baseUrl) {
    return {
        tag: "wztemplate",
        replace(state, tagInfo, _content) {
            const postNumber = tagInfo.attrs[POST_NUMBER_ATTRIBUTE_NAME];
            const topicId = tagInfo.attrs[TOPIC_ID_ATTRIBUTE_NAME];
            if (postNumber == null || topicId == null) {
                createMissingArgumentsPlaceholder(state);
            }
            else if (isPositiveWholeNumber(topicId) &&
                isPositiveWholeNumber(postNumber)) {
                createValidPlaceholder(state, parseInt(topicId, 10), parseInt(postNumber, 10), baseUrl, tagInfo.attrs);
            }
            else {
                createInvalidArgumentsPlaceholder(state);
            }
            return true;
        },
    };
}
/*
 * This is a workaround. Because this file can also run
 * in the context of the server (See lib/pretty_text.rb), getting
 * the base URL doesn't seem to work in the server, yet it doesn't
 * reproduce in a development server.
 *
 * Fallback to the known "/discuss" base path that we use in our
 * deployments in case of an error.
 */
function getBaseUrl(helper) {
    try {
        return helper.getOptions().getURL();
    }
    catch (e) {
        try {
            console.log("Failed to get baseUrl. Falling back to default value");
            console.log(e);
        }
        catch (_a) {
            // noop. We might not be able to log in every environment
        }
        return "/discuss";
    }
}
function setup(helper) {
    const baseUrl = getBaseUrl(helper);
    helper.registerPlugin((md) => {
        md.inline.bbcode.ruler.push("wztemplates", createWzTemplateRule(baseUrl));
    });
    helper.allowList({
        custom(tag, name, value) {
            if (name === "class" && value.startsWith("wz-template-")) {
                return true;
            }
            if (name === "rel" && value === "noopener noreferrer") {
                return true;
            }
            if (tag === "a" && name === "href" && value.startsWith("/t/")) {
                return true;
            }
            if (name === "class" && value.startsWith("w-icon-")) {
                return true;
            }
            if (tag === "svg" &&
                name === "class" &&
                value.includes("d-icon") &&
                value.includes("svg-icon")) {
                return true;
            }
            if (tag === "use" && name === "href") {
                return true;
            }
            if (tag === "span" && name === "slot") {
                return true;
            }
            return false;
        },
    });
    helper.registerOptions((opts) => {
        opts.features.bbcode = true;
    });
}

export { setup };
